import React, { useState, useEffect, useRef } from 'react'
import styled from 'styled-components'
import produce from 'immer'

const Wrapper = styled.div`
  margin-left: 30px;
  display: flex;
  align-items: flex-end;
`

const FilterLabel = styled.div`
  margin-right: 10px;
`

const InputWrapper = styled.div`
  margin-right: 8px;
`

const Label = styled.label`
  margin-bottom: 2px;
  display: block;
  font-size: 0.8rem;
`

const Input = styled.input`
  border: none;
  border-bottom: 1px solid #000;
  background-color: inherit;
`

const DateRange = ({ label = '', path = '', setFilters }) => {
  const [values, setValues] = useState({ from: '', to: '' })

  const didMountRef = useRef(false)

  useEffect(() => {
    if (didMountRef.current) {
      setFilters(produce(draft => {
        const index = draft.findIndex(filter => typeof filter === 'object' && path in filter)

        if (index !== -1) {
          if (!values.from && !values.to) {
            draft.splice(index, 1)
          }
          else {
            draft[index][path] = values
          }
        }
        else {
          draft.push({ [path]: values })
        }
      }))
    }
    else {
      didMountRef.current = true
    }
  }, [values])

  return (
    <Wrapper>
      <FilterLabel>{label}:</FilterLabel>
      <InputWrapper>
        <Label>Fr.o.m</Label>
        <Input type="date" value={values.from} onChange={e => setValues({ ...values, from: e.target.value })} />
      </InputWrapper>
      <InputWrapper>
        <Label>T.o.m</Label>
        <Input type="date" value={values.to} onChange={e => setValues({ ...values, to: e.target.value })} />
      </InputWrapper>
    </Wrapper>
  )
}

export default DateRange